import React, { memo, useCallback } from 'react';
import Div from '@/shared/Div';
import Container from '@/shared/Container';
import Heading from '@/shared/Heading';
import SkuCards from '@/shared/crisp/SkuCards';
import is from '@/utils/is';
import Carousel, { CarouselItem } from '@/shared/crisp/Carousel';
import classnames from 'classnames';
import withContentFlags from '@/hoc/withContentFlags';
interface Product {
  id: string;
  image: any;
  tag: {
    color?: string;
    text?: string;
  };
  title: string;
  subTitle?: string;
  description?: string;
}

interface NewLaunchesProps {
  title: string;
  list: Product[];
  app: boolean;
}

const NewLaunches = ({ title, list, app }: NewLaunchesProps) => {
  const renderBanner = useCallback((item: Product, index: number, isSnapPoint: boolean) => {
    return (
      <CarouselItem
        isSnapPoint={isSnapPoint}
        key={item.title + index}
        className="pl-6 last:pr-6 md:p-0 md:last:p-0"
      >
        <SkuCards
          className={classnames('w-[250px] md:w-[350px]', {
            'w-[288px]': app,
          })}
          dataTestId={`banner-${item.id}`}
          type="UpsellLarge"
          data={item}
        />
      </CarouselItem>
    );
  }, []);

  if (is.empty.array(list)) return null;

  return (
    <Div className="py-s8 md:py-s9 bg-cs-secondary">
      <Container className="flex flex-col gap-s6">
        <Heading
          level={3}
          className={classnames('text-h-1 md:text-hd-1 text-cm-primary', {
            'text-h-2': app,
          })}
        >
          {title}
        </Heading>
        <Carousel
          list={list}
          render={renderBanner}
          className="md:gap-s5 -mx-6 md:m-0 "
          hideProgressBar={app}
        />
      </Container>
    </Div>
  );
};

export default withContentFlags(memo(NewLaunches));
